/**
 * Componente Button
 * Wrapper para o Button do Ant Design
 */

import React from "react";
import { Button as AntButton } from "antd";

const Button = ({
  children,
  variant = "primary",
  size = "middle",
  type = "button",
  disabled = false,
  loading = false,
  fullWidth = false,
  icon: Icon,
  iconPosition = "left",
  onClick,
  className,
  ...props
}) => {
  // Mapeia variantes para tipos do Ant Design
  const variantMap = {
    primary: "primary",
    secondary: "default",
    outline: "default",
    ghost: "text",
    danger: "primary",
    success: "primary",
  };

  // Mapeia tamanhos
  const sizeMap = {
    sm: "small",
    md: "middle",
    lg: "large",
    xl: "large",
  };

  const buttonType = variant === "danger" ? "primary" : variantMap[variant] || "primary";
  const buttonSize = sizeMap[size] || "middle";

  // Estilos customizados baseados na variante
  // Removidos estilos inline para permitir que os estilos CSS globais funcionem
  // Os estilos CSS em index.css já configuram cores do tema corretamente
  const style = {
    width: fullWidth ? "100%" : undefined,
    // Não definir cores inline - deixar os estilos CSS globais fazerem o trabalho
    // Isso garante que os botões sigam o tema (claro/escuro) corretamente
  };

  // O Ant Design usa htmlType para o atributo HTML type (submit, button, etc)
  // e type para o estilo do botão (primary, default, etc)
  const htmlType = type === "submit" ? "submit" : type === "button" ? "button" : undefined;
  const antType = buttonType;

  return (
    <AntButton
      htmlType={htmlType}
      type={antType}
      size={buttonSize}
      disabled={disabled || loading}
      loading={loading}
      icon={Icon && iconPosition === "left" ? <Icon /> : undefined}
      onClick={onClick}
      className={className}
      style={style}
      {...props}
    >
      {children}
      {Icon && iconPosition === "right" && <Icon style={{ marginLeft: 8 }} />}
    </AntButton>
  );
};

export default Button;
